import { render, staticRenderFns } from "./EmpresaPendencias.vue?vue&type=template&id=3b97b8e7&scoped=true"
import script from "./EmpresaPendencias.vue?vue&type=script&lang=js"
export * from "./EmpresaPendencias.vue?vue&type=script&lang=js"
import style0 from "./EmpresaPendencias.vue?vue&type=style&index=0&id=3b97b8e7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97b8e7",
  null
  
)

export default component.exports